import { Injectable } from '@angular/core';

import type {
  NoteAvatarAuthor,
  NoteAvatarInputValues,
  NoteAvatarUpdateStrategy,
} from '../note-avatar.types';

@Injectable()
export class RtNoteAvatarUpdate implements NoteAvatarUpdateStrategy {
  public getValues({
    author,
    triggered,
  }: {
    author: NoteAvatarAuthor | null;
    triggered: boolean | null;
  }): NoteAvatarInputValues {
    const isDeletedUser = !triggered && !!author && !author.hasAvatar && !author.initials;
    const isActiveAuthor = !triggered && !!author && !isDeletedUser;
    return {
      type: isActiveAuthor ? (author!.hasAvatar ? 'image' : 'initials') : 'icon',
      context: !!author && !isDeletedUser ? (!!triggered ? 'candidate' : 'admin') : 'other',
      iconName: (!triggered && !author) || isDeletedUser ? 'person' : 'automated-actions',
      imageSrc:
        (!triggered && !author) || !!triggered || isDeletedUser
          ? null
          : (author?.photoThumbUrl ?? null),
      initials: author?.initials,
    };
  }
}
